var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-17",
    d: "M14.584 1H5.91479C2.8938 1 1 3.13802 1 6.16602V14.334C1 17.361 2.88479 19.5 5.91479 19.5H14.583C17.614 19.5 19.5 17.361 19.5 14.334V6.16602C19.5 3.13802 17.614 1 14.584 1Z",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 886",
    d: "M5.20703 6.79895H12.349",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 887",
    d: "M8.59375 5.91003V6.79903",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1061",
    d: "M12.165 13.603C10.282 13.731 7.62925 11.394 7.15625 9.39197",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1062",
    d: "M10.6768 6.79895C10.5564 8.22271 9.99413 9.57333 9.06885 10.6621C8.14357 11.7509 6.90132 12.5235 5.51562 12.8719",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path 1063",
    d: "M10.2578 14.589L12.7759 9.65796L15.2939 14.589",
    stroke: "#18173C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.03e19f2666609dd0cd8c7a9c90082cd9.svg";
export { ForwardRef as ReactComponent };